import { Component, OnInit } from "@angular/core";
import { ContentHeader } from "app/layout/components/content-header/content-header.component";
import { AuthService } from "../../util/service/auth.service";
import { CoreMenuService } from "../../../@core/components/core-menu/core-menu.service";
import { CoreMenu, CoreMenuItem } from "../../../@core/types";

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    standalone: false
})
export class HomeComponent implements OnInit {
  menu: CoreMenu[];
  public contentHeader: ContentHeader;

  constructor(
    public authService: AuthService,
    private _coreMenuService: CoreMenuService
  ) {}

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit() {
    this.menu = this._coreMenuService.getCurrentMenu().filter((item) => item.id !== "home");
    this.contentHeader = {
      headerTitle: "Startseite",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Startseite",
            isLink: true,
            link: "/",
            translate: "MENU.HOME",
          },
        ],
      },
    };
  }

  checkPermission(item: CoreMenuItem): boolean {
    return this._coreMenuService.checkPermission(item);
  }
}
